import { register, type GetIcons } from "@subly/s1/ui/icon";


const Icon = register({});

export type IconName = GetIcons<typeof Icon>;

export default Icon;